import api from '../../../../api'

export const FETCH_EVENTS_DRIVERS_PENDING = 'FETCH_EVENTS_DRIVERS_PENDING'
export const FETCH_EVENTS_DRIVERS_FULFILLED = 'FETCH_EVENTS_DRIVERS_FULFILLED'
export const FETCH_EVENTS_DRIVERS_REJECTED = 'FETCH_EVENTS_DRIVERS_REJECTED'

export const DELETE_EVENTS_DRIVERS_PENDING = 'DELETE_EVENTS_DRIVERS_PENDING'
export const DELETE_EVENTS_DRIVERS_FULFILLED = 'DELETE_EVENTS_DRIVERS_FULFILLED'
export const DELETE_EVENTS_DRIVERS_REJECTED = 'DELETE_EVENTS_DRIVERS_REJECTED'

export const CHANGE_EVENTS_DRIVERS = 'CHANGE_EVENTS_DRIVERS'

export function changeEventsDriversPeriod(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_EVENTS_DRIVERS, payload: { name, value } })
  }
}

export function findAllEventsDriversPeriods(filter) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_EVENTS_DRIVERS_PENDING });

    api({
      method: 'post',
      data: {
        query: `
                query findAllEventsDriversPeriods {
                  eventosMotoristaPorCliente (input: {
                    matriz: ${filter.matriz}
                    motorista: ${filter.motorista}
                    dataHoraInicial: "${filter.dataHoraInicial}"
                    dataHoraFinal: "${filter.dataHoraFinal}"
                  }) {
                    nome
                    conducaoBanguela
                    velocidadeSeco
                    velocidadeChuva
                    excessoRpm
                    freadaBrusca
                    aceleracaoMovimento
                    aceleracaoParado
                    excessoTemperatura
                    entradaUm
                    entradaDois
                    entradaTres
                    entradaQuatro
                    entradaCinco
                    entradaSeis
                    entradaSete
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_EVENTS_DRIVERS_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { eventosMotoristaPorCliente } = data
        dispatch({ type: FETCH_EVENTS_DRIVERS_FULFILLED, payload: eventosMotoristaPorCliente });
        resolve(eventosMotoristaPorCliente);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_EVENTS_DRIVERS_REJECTED, error });
      reject(error);
    });

  });

}
